
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { useQuestTypeList } from '@/modules/quest/type/model/list';
import { ROUTE_NAME_QUEST } from '@/modules/quest/router';
import { TableColumnType, TableConfig } from '@/components/table/types';
import { timeUnits } from '@/common/utils/helpers';

export default defineComponent({
    name: ROUTE_NAME_QUEST.TYPE.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, fetchList, actions } = useQuestTypeList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Option, label: 'Display Type', key: 'displayType', options: displayTypeList },
                { type: TableColumnType.Option, label: 'Time Unit', key: 'timeUnit', options: timeUnits },
                { type: TableColumnType.Text, label: 'Time Duration', key: 'timeDuration' },
                { type: TableColumnType.Text, label: 'Open Cycle', key: 'openCycle' },
                { type: TableColumnType.Text, label: 'Rest Cycle', key: 'restCycle' },
                { type: TableColumnType.Boolean, label: 'Is Enabled', key: 'isEnabled' },
                { type: TableColumnType.DateTime, label: 'Start Time', key: 'startTime' },
                { type: TableColumnType.DateTime, label: 'Next Start Time', key: 'nextStartTime' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'info',
                        tooltip: 'Detail',
                        to: { name: ROUTE_NAME_QUEST.TYPE.DETAIL, params: { typeId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-play',
                        theme: 'info',
                        tooltip: 'Enable next',
                        onclick: () => actions.enableNext(row.id)
                    }),
                    canShow: (row: any) => row.canEnable,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-stop',
                        theme: 'warning',
                        tooltip: 'Disable',
                        onclick: () => actions.disable(row.id)
                    }),
                    canShow: (row: any) => row.canDisable,
                    group: 2
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-stop',
                        theme: 'info',
                        tooltip: 'Disable next',
                        onclick: () => actions.disableNext(row.id)
                    }),
                    canShow: (row: any) => row.canDisableNext,
                    group: 2
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, displayTypeList, ROUTE_NAME_QUEST };
    }
});

const displayTypeList = [
    { label: 'Special', value: 1, background: 'success' },
    { label: 'Normal', value: 0, background: 'info' }
];
